import {DrupalJsonApiParams} from "drupal-jsonapi-params";
import {Certificate} from "types/hygiena-types";

/**
 * Searches for certificate lot numbers by product id.
 *
 * @param lotNumber
 *   The lot number to search by.
 * @param locale
 *   The locale.
 * @param defaultLocale
 *   The default locale.
 */
export async function certificateSearch(lotNumber: string, locale?: string, defaultLocale?: string) {
  let ok;
  lotNumber = lotNumber?.replace(/\s/g, '');
  let data: Certificate[] = [];
  let error = false;

  /**
   * Retrieves the expiration date check.
   * This function calculates the expiration date by subtracting 6 months from the current date.
   *
   * @returns {string} The expiration date in ISO 8601 format (yyyy-mm-dd).
   */
  const getExpirationDateCheck = (): string => {
    const date = new Date();
    date.setMonth(date.getMonth() - 6);
    return date.toISOString().split('T')[0];
  };

  if (lotNumber?.length) {
    try {
      const params = new DrupalJsonApiParams();
      params.addFilter('field_certificate_lot_number', lotNumber);
      params.addFilter('status', '1');
      params.addFilter('field_certificate_expiration_1', getExpirationDateCheck(), '>=');
      params.addInclude(['field_media_file,field_certificate_product.field_product_brand']);
      params.addFields('media--certificate', [
        'drupal_internal__mid',
        'field_certificate_lot_number',
        'field_certificate_expiration',
        'field_certificate_product',
        'field_certificate_label',
        'field_media_file',
      ]);
      params.addFields('node--product', [
        'title',
        'field_product_brand',
      ]);
      // Cache bust.
      params.addCustomParam({'timeStamp': new Date().getTime().toString()});

      // Add the locale prefix if not en.
      const res = await fetch(`/api/search/certificate`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "0"
        },
        body: JSON.stringify({
          locale,
          params: params.getQueryObject(),
        }),
        cache: "no-store",
      });

      const json = await res.json();
      data = json.certificates ?? [];
      ok = true;
    } catch (error) {
      ok = false;
      error = true;
    }
  }

  return {ok, data: data, error};
}
